import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import bn from '../../utils/bemnames';
import ErrorBoundary from './ErrorBoundary';

const DropdownList = ({
  isMulti = false,
  options = undefined,
  handleChange,
  handleInputChange = () => {},
  placeholder = 'Start typing to search...',
  maxHeight = 180,
  Dvalue,
  style,
  component,
  fullWidth,
  className,
  TrialUser,
  selectedValue = () => {},
  customSelectedValue,
  disabled,
  isClearable,
  classNames = '',
  showDropdownIndicator = false,
}) => {
  const bem = bn.create(`dropdownList${disabled ? '-disabled' : ''}`);

  const selectComponents = {
    ...(!showDropdownIndicator ? { IndicatorSeparator: () => null } : {}),
    ...(showDropdownIndicator || component ? {} : { DropdownIndicator: () => null }),
    ...(component ? { DropdownIndicator: component } : {}),
  };

  const reactSelectStyles = {
    menuList: (base) => ({
      ...base,
      padding: 0,
      minHeight: '100px',
      '::-webkit-scrollbar': {
        width: '10px',
        backgroundColor: '#ffffff',
      },
      '::-webkit-scrollbar-track': {
        WebkitBoxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
      },
      '::-webkit-scrollbar-thumb': {
        backgroundColor: '#183f74',
        border: '2px solid #ffffff',
      },
    }),
    control: (provided) => ({
      ...provided,
      minHeight: 38,
      minWidth: 0,
      maxWidth: '100%',
      flexWrap: 'nowrap',
    }),
    container: (base) => ({
      ...base,
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
    }),
    valueContainer: (base) => ({
      ...base,
      minWidth: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      color: '#1e1e1e',
      backgroundColor: state.isSelected ? '#f5f8f9' : state.isFocused ? '#E6E6E6' : 'white',
    }),
  };

  if (typeof selectedValue === 'object' || customSelectedValue) {
    return (
      <ErrorBoundary>
        <div className={bem.b(`${classNames}`)}>
          <Select
            cacheOptions
            defaultOptions
            isMulti={isMulti}
            value={selectedValue}
            options={options}
            getOptionLabel={(e) => e?.label}
            getOptionValue={(e) => e?.value}
            onInputChange={handleInputChange}
            onChange={handleChange}
            placeholder={placeholder}
            components={selectComponents}
            maxMenuHeight={maxHeight}
            defaultValue={Dvalue}
            styles={style !== undefined ? style : reactSelectStyles}
            menuPlacement="auto"
            className={`insightia-select ${className || ''} ${fullWidth ? 'w-100' : ''}`.trim()}
            classNamePrefix="insightia-select"
            isDisabled={disabled}
            isClearable={isClearable !== undefined ? isClearable : true}
            theme={getThemeForSelect}
          />
        </div>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary>
      <div className={bem.b(`${classNames}`)}>
        <Select
          cacheOptions
          defaultOptions
          isMulti={isMulti}
          options={options}
          getOptionLabel={(e) => e?.label}
          getOptionValue={(e) => e?.value}
          onInputChange={handleInputChange}
          onChange={handleChange}
          placeholder={placeholder}
          components={selectComponents}
          maxMenuHeight={maxHeight}
          defaultValue={Dvalue}
          value={Dvalue}
          menuPlacement="auto"
          styles={style !== undefined ? style : reactSelectStyles}
          className={`insightia-select ${className || ''} ${fullWidth ? 'w-100' : ''}`.trim()}
          classNamePrefix="insightia-select"
          isDisabled={disabled}
          isClearable={isClearable !== undefined ? isClearable : true}
          theme={getThemeForSelect}
        />
      </div>
    </ErrorBoundary>
  );
};

DropdownList.propTypes = {
  isMulti: PropTypes.bool,
  selectedValue: PropTypes.any,
  options: PropTypes.any,
  handleChange: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func,
  placeholder: PropTypes.string,
  maxHeight: PropTypes.number,
  Dvalue: PropTypes.any,
  style: PropTypes.any,
  component: PropTypes.any,
  classNames: PropTypes.string,
  showDropdownIndicator: PropTypes.bool,
};

export default React.memo(DropdownList);

function getThemeForSelect(theme) {
  return {
    ...theme,
    colors: {
      ...theme.colors,
      primary: '#4382f7',
      neutral20: '#949494',
    },
  };
}
